/**
 * Local wall-clock stamps for the Signals surface — the same clock as the
 * queue and storyline rows (core-shell shortTime). One formatter so the
 * pane, the storyline graph and the Kill Chain never disagree on a zone.
 */

/** `YYYY-MM-DD HH:mm:ss`, local time. */
export function absTime(at: number): string {
  const d = new Date(at)
  const p = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
}

/** `MM-DD HH:mm`, local time; `—` when the time is unknown. */
export const monthDayTime = (at: number | null): string => (at === null ? '—' : absTime(at).slice(5, 16))

/** `MM-DD HH:mm–MM-DD HH:mm`; a single `—` when neither end is known. */
export const timeSpan = (start: number | null, end: number | null): string =>
  start === null && end === null ? '—' : `${monthDayTime(start)}–${monthDayTime(end)}`

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/** `6 Oct 2026, 3:14:00 PM`, local — the storyline graph's signal hover card (legacy look). */
export function cardTime(at: number): string {
  const d = new Date(at)
  const h = d.getHours() % 12 || 12
  const p = (n: number) => String(n).padStart(2, '0')
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}, ${h}:${p(d.getMinutes())}:${p(d.getSeconds())} ${d.getHours() < 12 ? 'AM' : 'PM'}`
}
